import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/components/ContactPageView.tsx");
